import React from "react";
import { MapPin, Users, Sprout, Network, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const philosophyPoints = [{
  title: "Local Expertise",
  description: "Deep knowledge of Broward County's unique building codes and coastal environmental factors.",
  icon: MapPin
}, {
  title: "Detailed Reporting",
  description: "Comprehensive digital reports delivered within 24 hours, featuring high-resolution imagery.",
  icon: Users
}, {
  title: "Safety First",
  description: "Identifying structural risks and hazards to ensure your family's long-term peace of mind.",
  icon: Sprout
}, {
  title: "Professional Network",
  description: "Trusted by South Florida realtors and homeowners for reliable, unbiased property assessments.",
  icon: Network
}];
export default function Loyal2SoilPhilosophy() {
  return <section data-section-id="247719" id="overview" className="bg-background text-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          <div className="flex flex-col space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
                Broward County Specialists
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground tracking-tight">
                Trusted Home Inspections in Broward
              </h2>
              <p className="text-lg text-muted-foreground max-w-xl leading-relaxed font-sans">
                Protecting your investment requires more than a glance. Our certified inspectors provide the thorough analysis needed for South Florida's diverse residential landscape, from Fort Lauderdale to Pembroke Pines.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {philosophyPoints.map((point, i) => {
              const Icon = point.icon;
              return <div key={i} data-index={i} className="flex flex-col space-y-3">
                    <div className="h-12 w-12 rounded-lg bg-primary/5 flex items-center justify-center border border-primary/10">
                      <Icon className="h-6 w-6 text-primary" />
                    </div>
                    <h3 className="text-xl font-semibold font-default text-foreground">
                      {point.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed font-sans">
                      {point.description}
                    </p>
                  </div>;
            })}
            </div>

            <div className="pt-4">
              <Button size="lg" className="group bg-primary text-primary-foreground hover:bg-primary/90 shadow-md" asChild>
                <Link to="https://trusted-fl.com/#schedule-your-inspection">
                  Schedule Your Inspection
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          <div className="relative w-full max-w-xl mx-auto lg:max-w-none">
            <div className="absolute -inset-4 bg-primary/5 rounded-3xl transform rotate-3 scale-105 -z-10 hidden md:block"></div>
            <div className="absolute -inset-4 bg-secondary/5 rounded-3xl transform -rotate-2 scale-105 -z-10 hidden md:block"></div>
            
            <div className="rounded-2xl overflow-hidden shadow-2xl border border-border/50 bg-card">
              <AspectRatio ratio={4 / 5} className="w-full h-full">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/broward_county_residential_inspection.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/broward_county_residential_inspection.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/broward_county_residential_inspection.png-wvc-sizes" alt="Professional home inspector examining a Broward County property" className="object-cover w-full h-full" loading="lazy" />
              </AspectRatio>
            </div>
            
            <div className="absolute -bottom-6 -left-6 md:-bottom-8 md:-left-8 bg-background p-4 rounded-xl shadow-xl border border-border flex items-center gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300">
              <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
                <Sprout className="h-6 w-6 text-primary" />
              </div>
              <div>
                <p className="text-sm font-bold font-default text-foreground">Certified in</p>
                <p className="text-xs text-muted-foreground">South Florida Safety</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}